export const RECEIVE_HOME = "RECEIVE_HOME";
export const RECEIVE_CHARACTER = "RECEIVE_CHARACTER";
export const RECEIVE_AUTHORS = "RECEIVE_AUTHORS";
export const RECEIVE_IMOVEISCACHE = "RECEIVE_IMOVEISCACHE";
export const RECEIVE_PAGINATION = "RECEIVE_PAGINATION";


